<template>
  <div>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
    >
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border"
          @click="onTabChange(false)"
          :class="!isDeducted ? 'bg-primary' : 'bg-primary-light'"
      >
        {{ translation(translationList.standard_fare, 'Tarif standard') }}
      </div>
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border"
          @click="onTabChange(true)"
          :class="isDeducted ? 'bg-primary' : 'bg-primary-light'"
      >
        {{ translation(translationList.deducted_price, 'Decontare directă') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'RcaisDeductedTab',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, {emit}) {
    const isDeducted = ref(props.modelValue);
    const translationList = ref<TranslationList>({});

    const translationStore = useTranslationStore();

    const onTabChange = (newValue: boolean) => {
      isDeducted.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.modelValue, (newValue) => {
      isDeducted.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    return {
      isDeducted,
      onTabChange,
      translationList,
      translation,
    };
  },
});
</script>

<style scoped>

</style>
